/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const b2cPolicies = {
	names: {
		signUpSignIn: "B2C_1_MS_SIGN_UP_IN",
	},
	authorities: {
		signUpSignIn: {
			authority: "https://login.microsoftonline.com/f0d162a2-a074-489d-b6f6-961c4947c7a1/"
		}
	},
	authorityDomain: "iamcpsmdatadev.b2clogin.com"
};



export const msalConfig = {
	auth: {
		// clientId: "2d2c3723-8a3b-4cec-97d2-fa0ff1728e9c", // B2C Application (client) ID
		// clientId: "1603fa39-9323-402c-a6b7-fc484de55e6f", // B2B Application (client) ID
		clientId: "1d54d0f5-57dc-434e-be58-129f0b7f0b68", // B2B Application (client) ID - kon

		// clientId: "1790d7b2-7398-4ca1-944c-9bcca681f895", // B2B Application (client) ID - server principal
		authority: b2cPolicies.authorities.signUpSignIn.authority, // Directory (tenant) ID
		redirectUri: process.env.REACT_APP_LOCAL_REDIRECT || "https://dev.data.infrastructureaustralia.gov.au/",
		// knownAuthorities: [b2cPolicies.authorityDomain],
		postLogoutRedirectUri: process.env.REACT_APP_LOCAL_REDIRECT || "https://dev.data.infrastructureaustralia.gov.au/",
	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			logLevel: LogLevel.Warning,
			loggerCallback: (level: any, message: any, containsPii: boolean) => {
				if (containsPii) {
					return;
				}
				switch (level) {
				case LogLevel.Error:
					console.error(message);
					return;
				case LogLevel.Info:
					console.info(message);
					return;
				case LogLevel.Verbose:
					console.debug(message);
					return;
				case LogLevel.Warning:
					console.warn(message);
					return;
				default:
					return;
				}
			}
		}
	}
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

// Endpoint.Access
//
// user_impersonation
//
// administer
//
export const loginRequest = {
	scopes: ["openid", "profile", "api://data_api_builder_dev/Endpoint.Access"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
